/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Einvoice_Settings_PasswordInputs */

const vi_einvoice_settings_password = /** @type {(inputs: Einvoice_Settings_PasswordInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mật khẩu`)
};

/**

* @param {Einvoice_Settings_PasswordInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const einvoice_settings_password = /** @type {((inputs?: Einvoice_Settings_PasswordInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Einvoice_Settings_PasswordInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_einvoice_settings_password(inputs)
});